<!-- 部门操作 -->
<template>
    <div>
        <el-drawer :close-on-press-escape="true" title="我是标题" :visible.sync="dataActionBox.showStatus" :with-header="false"
            :append-to-body="true" :direction="dataActionBox.openMode" size="50%">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="formDataList">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
                        :tabslist="formDataList" @tabs="(val) => { showTabs = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form size="mini" inline :model="sendDataInfo" label-width="150px" ref="sendDataInfo"
                                        :show-message="false">
                                        <el-form-item label="归属部门"
                                            :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                            <label slot="label" :style="$common.labelStyle('归属部门')" v-html="$common.htmlLabel('归属部门')"></label>
                                            <el-cascader class="form_codition" ref="pdepId" v-model="selectDepartmentPath"
                                                @change="selectPath" :options="allDepartmentList"
                                                :props="{ checkStrictly: true, expandTrigger: 'hover', emitPath: false }">
                                                <template slot-scope="{ node, data }">
                                                    <span>{{ data.label }}</span>
                                                    <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                                                </template>
                                            </el-cascader>
                                        </el-form-item>
                                        <el-form-item label="部门编码" prop="depCode"
                                            :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                            <label slot="label" :style="$common.labelStyle('部门编码')" v-html="$common.htmlLabel('部门编码')"></label>
                                            <el-input class="form_codition" v-model.trim="sendDataInfo.depCode"
                                                :maxlength="$store.state.inputLength" placeholder="选择完归属自动生成"></el-input>
                                        </el-form-item>
                                        <el-form-item label="部门名称" prop="depName"
                                            :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                            <label slot="label" :style="$common.labelStyle('部门名称')" v-html="$common.htmlLabel('部门名称')"></label>
                                            <el-input class="form_codition" v-model.trim="sendDataInfo.depName"
                                                :maxlength="$store.state.inputLength"></el-input>
                                        </el-form-item>
                                        <el-form-item label="科目" prop="depSuject">
                                            <label slot="label" :style="$common.labelStyle('科目')" v-html="$common.htmlLabel('科目')"></label>
                                            <el-input class="form_codition" v-model.trim="sendDataInfo.depSuject"
                                                :maxlength="$store.state.inputLength"></el-input>
                                        </el-form-item>
                                    </el-form>
                                </div>

                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <div class="foots">
                    <el-button type="primary" @click="dataActionBox.showStatus = false"
                        v-if="dataActionBox.actionType != 2">取消</el-button>
                    <el-button type="primary" @click="sendDataAction()"
                        v-if="dataActionBox.actionType == 0">保存</el-button>
                    <el-button type="primary" @click="sendDataAction()"
                        v-if="dataActionBox.actionType == 1">保存</el-button>
                    <!-- <el-button type="primary" v-if="dataActionBox.actionType==3" @click="submitData()">提交供货商</el-button> -->
                </div>
            </div>

        </el-drawer>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
    name: 'departmentAction',
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                showStatus: false,
                openMode: 'ltr' || 'rtl',
                boxTitle: '新增' || '编辑',
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                depCode: '',
                depName: '',
                pdepId: '',
                depId: '',
                depSuject: '',  //科目
            },
            formDataList: [],
            showTabs: '',
            allDepartmentList: [],
            selectDepartmentPath: []

        };
    },
    //监听属性 类似于data概念
    computed: {
    },
    //监控data中的数据变化
    watch: {
    },
    //方法集合
    methods: {
        async selectPath() {
            var newData = this.$refs.pdepId.getCheckedNodes(true)
            var codes = await this.$common.createDepartmentCode(newData[0].data.depCode, newData[0].data.value)
            this.sendDataInfo.pdepId = this.selectDepartmentPath == -1 ? 0 : this.selectDepartmentPath;
            this.sendDataInfo.depCode = codes
        },
        initActionBox() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = ''
            }

            this.sendDataInfo.pdepId = 0
            this.selectDepartmentPath = -1

            this.dataActionBox.actionType = 0
            this.dataActionBox.showStatus = false
        },



        async openBox(cate, oldData = '') {
            this.initActionBox()
            this.sendDataInfo.depCode = await this.$common.createDepartmentCode('', -1)
            if (cate == 0) {
                this.dataActionBox.boxTitle = '新增信息'
                this.dataActionBox.openMode = 'ltr'
                this.showTabs = "新增部门信息"
                this.formDataList = [
                    {
                        jciName: "新增部门信息",
                        jurconfigform: [],
                    }
                ]
            } else {
                this.dataActionBox.boxTitle = '编辑信息'
                this.dataActionBox.openMode = 'ltr'
                for (let key in oldData) {
                    this.$set(this.sendDataInfo, key, oldData[key])
                }
                this.selectDepartmentPath = this.sendDataInfo.pdepId == 0 ? -1 : this.sendDataInfo.pdepId
                this.formDataList = [
                    {
                        jciName: "编辑部门信息",
                        jurconfigform: [],
                    }
                ]
                this.showTabs = "编辑部门信息"

            }
            this.dataActionBox.actionType = cate
            this.dataActionBox.showStatus = true

        },
        // 获取全部部门
        async getAllDepartmentList() {
            var initArr = [
                { value: -1, label: '顶级部门', pdepId: 0, 'level': 0, children: [] }
            ]
            let requestData = await this.$http.getAllDepartmentList()
            if (requestData.status == 200) {
                initArr[0].children = this.departmentListMenu(requestData.result)
            }
            this.allDepartmentList = initArr
        },
        // 整理部门树
        departmentListMenu(data, id = 0, lev = 0, selectId = '') {
            var son = []
            data.forEach((value, keys) => {
                if (selectId == value['depId']) {
                    value['disabled'] = true;
                }
                if (value['pdepId'] == id) {
                    value['value'] = value['depId']
                    value['label'] = value['depName']
                    value['level'] = lev;
                    var list = this.departmentListMenu(data, value['depId'], lev + 1);
                    if (list.length >= 1) {
                        value['children'] = list
                    }
                    son.push(value)
                }
            })
            return son;
        },
        async getALLOrg() {
            this.allorgList = await this.$common.getALLOrg()
        },
        async sendDataAction() {
            if (this.sendDataInfo.orgCode == '') {
                this.$message({
                    message: '请填写编码',
                    type: 'error'
                });
                return false
            }
            if (this.sendDataInfo.orgName == '') {
                this.$message({
                    message: '请填写名称',
                    type: 'error'
                });
                return false
            }
            var sendDataInfo = JSON.parse(JSON.stringify(this.sendDataInfo))
            if (this.dataActionBox.actionType == 0) {
                var responseData = await this.$http.addDepartment(sendDataInfo)
            } else {
                var responseData = await this.$http.editDepartment(sendDataInfo)
            }
            if (responseData.status == 200) {
                this.initActionBox()
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });

                this.$parent.getDataList()

            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },



    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getAllDepartmentList()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {
    }, //生命周期 - 创建之前
    beforeMount() {
    }, //生命周期 - 挂载之前
    beforeUpdate() {
    }, //生命周期 - 更新之前
    updated() {
    }, //生命周期 - 更新之后
    beforeDestroy() {
    }, //生命周期 - 销毁之前
    destroyed() {
    }, //生命周期 - 销毁完成
    activated() {
    }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>